import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { lazy, Suspense } from 'react';
import { SubPageLoadingSpinner } from '../components/subPageLoadingSpinner';
const TermsPageContents = lazy(() => import(/* webpackChunkName: "terms" */ './termsPageContents'));
export const TermsPage = () => {
    return (_jsx(Suspense, { fallback: _jsx(SubPageLoadingSpinner, {}), children: _jsx(TermsPageContents, {}) }));
};
